import {
  get,
  post,
  patch,
  deletes,
} from './base/index';

export default {
  getUsers: (data = {}) => {
    const params = { ...data, limit: 20 };
    return get(`${process.env.REACT_APP_API_URL}cms/v2/users`, { params });
  },
  userExport: (data = {}) => {
    const params = { ...data };
    return get(`${process.env.REACT_APP_API_URL}cms/v2/users/export-data`, { params });
  },
  getSingleUser: (data = 0) => get(`${process.env.REACT_APP_API_URL}cms/v1/users/${data}`, {}),
  changeWalkthroughUser: (data = 0) => patch(`${process.env.REACT_APP_API_URL}cms/v1/users/walkthrough/${data}`, {
    walkthrough: true,
  }),
  addUser: (data = {}) => {
    const body = { ...data };
    return post(`${process.env.REACT_APP_API_URL}cms/v1/users`, body, true);
  },
  updateUser: (data = {}) => {
    const params = {
      name: data.name,
      // email: data.email,
      role: data.role,
      user_name: data.user_name,
      profile_image: data.profile_image || null,
      stores: data.stores,
      is_update_notified: data.notified,
      remove_image: data.remove_image,
    };
    return patch(`${process.env.REACT_APP_API_URL}cms/v2/users/${data.id}`, params, true);
  },
  updateProfile: (data = {}) => {
    const params = {
      email: data.email,
      name: data.name,
      role: data.role,
      user_name: data.user_name,
      profile_image: data.profile_image,
      remove_image: data.remove_image,
    };
    return patch(`${process.env.REACT_APP_API_URL}cms/v1/users/profile/${data.id}`, params, true);
  },
  deleteUser: (data = 0) => deletes(`${process.env.REACT_APP_API_URL}cms/v1/users/${data}`, {}),
  getAllUsers: (data = {}) => {
    const params = { ...data };
    return get(`${process.env.REACT_APP_API_URL}cms/v1/users/getUsersList`, { params });
  },
  getFilterData: () => get(`${process.env.REACT_APP_API_URL}cms/v2/users/filter-data`, {}),
};
